import React from 'react';
export function Footer() {
  return <footer className="bg-mist border-t border-hair py-[46px] pb-[30px]" data-id="element-24">
      <div className="max-w-page mx-auto px-6" data-id="element-25">
        <div className="flex flex-wrap justify-between gap-6 items-start" data-id="element-26">
          <div data-id="element-27">
            <div className="font-display font-semibold text-[1.2rem]" data-id="element-28">
              Fermata Wellbeing
            </div>
            <div className="text-[0.85rem] text-ink-60 mt-[6px]" data-id="element-29">
              Evidence-based living · Be still.
            </div>
          </div>

          <nav className="flex flex-wrap gap-[18px] text-[0.82rem] text-ink-60" aria-label="Footer" data-id="element-30">
            <a href="https://www.fermatawellbeing.com" target="_blank" rel="noopener noreferrer" className="no-underline hover:text-ink transition-colors" data-id="element-31">
              About
            </a>
            <a href="https://www.wearchime.com/pages/contact" target="_blank" rel="noopener noreferrer" className="no-underline hover:text-ink transition-colors" data-id="element-32">
              Contact
            </a>
            <a href="https://www.wearchime.com/pages/shipping-policy" target="_blank" rel="noopener noreferrer" className="no-underline hover:text-ink transition-colors" data-id="element-33">
              Shipping
            </a>
            <a href="https://www.wearchime.com/pages/refund-policy" target="_blank" rel="noopener noreferrer" className="no-underline hover:text-ink transition-colors" data-id="element-34">
              Refund &amp; Returns
            </a>
            <a href="https://www.wearchime.com/pages/privacy-policy" target="_blank" rel="noopener noreferrer" className="no-underline hover:text-ink transition-colors" data-id="element-35">
              Privacy
            </a>
            <a href="https://www.wearchime.com/pages/terms-of-service" target="_blank" rel="noopener noreferrer" className="no-underline hover:text-ink transition-colors" data-id="element-36">
              Terms
            </a>
          </nav>
        </div>

        <p className="max-w-[720px] mt-[26px] pt-[20px] border-t border-hair text-[0.74rem] text-ink-40 leading-[1.55] m-0" data-id="element-37">
          Chime is a wellness tool, not a medical device. It is not intended to
          diagnose, treat, cure, or prevent any disease or condition, including
          anxiety or nicotine dependence. Statements have not been evaluated by
          the FDA. Consult a healthcare professional for medical concerns.
        </p>
      </div>
    </footer>;
}